<div class="nugget-item cursor-normal">
  <div class="nugget_subject nugget_subject-auto mb-15">{{skills['key'] | slice:1}}</div>
  <span class="skill-chip" *ngFor="let skill of skills['value'] | slice:0:displayNumber">{{skill['name']}}</span>
  <span class="skill-chip skill-chip-more" *ngIf="moreSkills > 0" (click)="open()">+{{moreSkills}}</span>
</div>